<template>
  <div
    class="bg-[#f7f9fb] font-[Plus_Jakarta_Sans] font-normal min-h-screen flex flex-col"
  >
    <Navigation />
    <main class="flex-1">
      <slot />
    </main>
    <footer class="bg-[#f2f4f6] border-t border-[#eceef0] py-10">
      <div class="max-w-[1280px] mx-auto px-4 md:px-6">
        <div
          class="flex flex-col md:flex-row items-start justify-between gap-8"
        >
          <!-- Logo + copyright -->
          <div class="flex flex-col gap-2">
            <Link :href="navData.rootPath" class="flex items-center gap-2.5">
              <EmmalagatLogo width="163" />
            </Link>
            <p class="text-xs text-[#6c7a77] leading-relaxed">
              © 2026 Emmalagat. Handgjort med kärlek<br />och socker.
            </p>
          </div>

          <!-- Footer links -->
          <div class="flex flex-wrap gap-6 md:gap-10">
            <Link
              :href="navData.recipesPath"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase no-underline hover:text-teal-500 transition-colors"
              >Alla recept</Link
            >
            <Link
              :href="navData.categoriesPath"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase no-underline hover:text-teal-500 transition-colors"
              >Kategorier</Link
            >
            <Link
              :href="navData.toolsPath"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase no-underline hover:text-teal-500 transition-colors"
              >Tekniker &amp; verktyg</Link
            >
            <a
              href="https://www.instagram.com/emmalagat.se/"
              target="_blank"
              rel="noopener noreferrer"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase no-underline hover:text-teal-500 transition-colors"
              >Instagram</a
            >
            <Link
              :href="navData.designSystemPath"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase no-underline hover:text-teal-500 transition-colors"
              >Designsystem</Link
            >
          </div>
        </div>
      </div>
    </footer>
    <Sonner position="bottom-right" rich-colors />
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import { toast } from "vue-sonner";
import Navigation from "@/components/navigation/Navigation.vue";
import Sonner from "@/components/ui/sonner/Sonner.vue";
import EmmalagatLogo from "@/components/icons/EmmalagatLogo.vue";

const page = usePage();
const navData = computed(() => page.props.navData);

watch(
  () => page.props.flash,
  (flash) => {
    if (flash?.notice) toast.success(flash.notice);
    if (flash?.alert) toast.error(flash.alert);
  },
  { immediate: true },
);
</script>
